// extracted by mini-css-extract-plugin
export default {"footer":"jdILke","media":"JOAVzN","tags":"RggeF7","tagIcon":"k0JdDv"};